import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';
import { ENERGY_USERS_ADMIN } from '../../App';

const TotalTr = ({ totals = {}, profileType = '', profile }) => {
  const { extraShareTotals = 0, adminShareTotals = 0 } = totals;

  return (
    <tr className="summary-tr">
      <td>-</td>
      {profileType === 'EON_ENERGY' && <td>-</td>}
      {profileType === 'EON_ENERGY' && <td>-</td>}
      {ENERGY_USERS_ADMIN.includes(profileType) && <td>-</td>}
      {ENERGY_USERS_ADMIN.includes(profileType) && <td>-</td>}
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      {(profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)) && (
        <td>-</td>
      )}
      <td>-</td>
      {(profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)) && (
        <td>-</td>
      )}
      <td>-</td>
      <td>-</td>
      <td>-</td>
      {profile.polis === true && <td>-</td>}
      {profile.polis === true && <td>-</td>}
      {profile.polis === true && <td>-</td>}
      {profile.polis === true && <td>-</td>}
      {profile.polis === true && (
        <td className="txt-table-right">{formatCurrency(extraShareTotals)}</td>
      )}
      {(profile.polis === true || ENERGY_USERS_ADMIN.includes(profileType)) && (
        <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
      )}
      <td>-</td>
      {profile.polis === true && <td>-</td>}
      {profile.polis !== true && profileType === 'EON_ENERGY' && <td>-</td>}
      <td>-</td>
      {ENERGY_USERS_ADMIN.includes(profileType) && <td>-</td>}
      {profile.polis === true && <td>-</td>}
      {profile.polis === true && <td>-</td>}
    </tr>
  );
};

export default TotalTr;
